<template>
<div class="hot-play">
    <div class="blk-title">看看大家去哪玩</div>
    <div class="list-box">
        <ul class="list">
            <li v-for="(item,index) in list " :key="index">
                <a :href="item.url" target="_blank" class="cover-img"><div class="img-box"><img :src="item.img" alt=""></div></a>
                <a :href="item.url" target="" class="title">{{item.title}}</a>
            </li>
        </ul>
    </div>
</div>
</template>
<script>
export default {
    name:'HotPlay',
    data(){
        return {
            list :[
                {
                    title:'多伦多13个遛娃宝藏公园',
                    url:'https://news.yorkbbs.ca/detail/events/84a7a8c2-b469-4dbd-bc32-38cff2981a55',
                    img:'https://media7.imgyb.xyz/media/v1/image/43313308dd10b211136d360c2f0d3b1a.jpeg',
                },
                {
                    title:'多伦多地区最受家庭欢迎的亲子骑车路线',
                    url:'https://news.yorkbbs.ca/detail/travel/262cdb1d-c90a-4216-aeab-b15249d9858c',
                    img:'https://media7.imgyb.xyz/media/v1/image/3a434eccb31d818f4f7f4f3d7543cafe.jpeg',
                },
                {
                    title:'盘点多伦多周边的6个动物园：码住收藏，去打卡！',
                    url:'https://forum.yorkbbs.ca/detail/9253fbd5-fb2c-4158-b7a4-9bcbf1d6c46d?topic=chat',
                    img:'https://media1.imgyb.xyz/media/v1/image/fa1456069de0c8d44c48adaece2e07ab.jpeg',
                },
                {
                    title:'每周推荐遛娃最强攻略',
                    url:'https://info.yorkbbs.ca/special/big/865701de-2ceb-4341-bb39-f11bfe9c66d4',
                    img:'https://media6.imgyb.xyz/media/v1/image/02b51b9b6ce48c708939c17f67d9b5bd.jpeg',
                },
                {
                    title:'6月Cineplex合家欢电影清单来啦！',
                    url:'https://news.yorkbbs.ca/detail/local/154e7195-1d9f-40cf-80c7-3c1745ceb305',
                    img:'https://media1.imgyb.xyz/media/v1/image/bd832b5296a50f3bd67ee9b9fb74638b.jpeg',
                },
                {
                    title:'ToysRus 6月免费儿童活动，免费参加',
                    url:'https://news.yorkbbs.ca/detail/events/7be1bb61-d442-4361-93b2-4a47a7957d6c',
                    img:'https://media3.imgyb.xyz/media/v1/image/82bc5079426efc8174a04225fff80b34.jpeg',
                },
            ]
        }
    }
}
</script>
<style lang="less" scoped>
.hot-play{
    margin-top: 30px;
    .blk-title{

        font-size: 26px; text-align: center; margin-bottom: 20px ;
    }
    .list-box{
        background: #fff; border-radius: 4px; padding: 20px 20px 0;
        ul{
            display: flex; flex-wrap: wrap; margin: 0 -15px;
            li{
                width: 33.33%; padding: 0 15px; box-sizing: border-box; margin-bottom: 30px;
                a{
                    display: block;
                    position: relative;
                }
                .img-box{
                    position: relative; padding-bottom: 62.5%; overflow: hidden; border-radius: 4px;
                    img{
                        position: absolute; left: 0;  top: 0; width: 100%; height: 100%; object-fit: cover; transition: all 200ms linear;
                    }
                    &:hover{
                        img{transform: scale(1.2); }
                    }
                }
                .title{
                    font-size: 16px; line-height: 26px; color: #111; margin-top: 15px;
                    &:hover{color: #e43a3a;}
                }
            }
        }
    }
}
@media screen and (max-width:768px){
    .hot-play{
        margin-top: 20px;
        .blk-title{font-size: 18px;}
        .list-box{
            padding: 10px 10px 0;
            ul{
                margin: 0 -10px;
                li{
                    width:50%; padding: 0 10px; margin-bottom: 15px;
                }
            }
        }
    }
}
</style>